/** Conference ticket purchase URLs (first-party 2027; TT for 2026). */

export const TICKET_PURCHASE_URL_2026 = "https://tickettailor.com/events/dataengbytes/";

export const TICKET_PURCHASE_URL = "https://dataengbytes.com/2027/tickets";

export const TICKET_PURCHASE_LABEL = "dataengbytes.com/2027/tickets";

export function ticketPurchaseUrlForEvent(eventId: string): string {
  if (eventId.startsWith("deb2027-")) {
    const city = eventId.replace("deb2027-", "");
    return `https://dataengbytes.com/2027/${city}/tickets`;
  }
  if (eventId.startsWith("deb2026-")) {
    return TICKET_PURCHASE_URL_2026;
  }
  return TICKET_PURCHASE_URL;
}

export const CITY_LABELS: Record<string, string> = {
  "deb2026-melbourne": "Melbourne 2026",
  "deb2026-sydney": "Sydney 2026",
  "deb2027-brisbane": "Brisbane 2027",
  "deb2027-auckland": "Auckland 2027",
  "deb2027-perth": "Perth 2027",
  "deb2027-adelaide": "Adelaide 2027",
  "deb2027-melbourne": "Melbourne 2027",
  "deb2027-sydney": "Sydney 2027",
};

export function cityLabel(eventId: string): string {
  return CITY_LABELS[eventId] ?? eventId;
}
